export default __webpack_public_path__ + "static/media/1 - Psychic Waves.a1538e6d.mp3";